import React from 'react';
import SectionTitle from '../ui/SectionTitle';
import Card, { CardContent } from '../ui/Card';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './AboutContent.css';

const AboutContent = () => {
    const [sectionRef, isSectionVisible] = useScrollAnimation(0.1);
    const [titleRef, isTitleVisible] = useScrollAnimation(0.1);
    const [descRef, isDescVisible] = useScrollAnimation(0.1);
    const [missionRef, isMissionVisible] = useScrollAnimation(0.1);
    const [visionRef, isVisionVisible] = useScrollAnimation(0.1);

    return ( <
        section className = "about-content"
        ref = { sectionRef } >
        <
        div className = "container" >
        <
        div ref = { titleRef }
        className = { `animate-on-scroll ${isTitleVisible ? 'visible' : ''}` } >
        <
        SectionTitle subtitle = "ABOUT US"
        title = "Effective Communication & Professional Recovery" / >
        <
        /div>

        <
        div className = { `about-description animate-on-scroll delay-1 ${isDescVisible ? 'visible' : ''}` }
        ref = { descRef } >
        <
        p >
        At Dynamic Enterprises, we believe that effective communication and professional debt recovery are essential
        for maintaining healthy business operations.Our team of trained agents handles every interaction with professionalism, respect, and compliance with industry regulations. <
        /p> <
        /div>

        <
        div className = "mission-vision-grid" >
        <
        div className = { `fade-in-left ${isMissionVisible ? 'visible' : ''}` }
        ref = { missionRef } >
        <
        Card >
        <
        CardContent >
        <
        h3 > Our Mission < /h3> <
        p >
        To provide reliable and ethical call center and debt recovery services that help businesses improve cash flow, strengthen customer relationships, and achieve sustainable growth. <
        /p> <
        /CardContent> <
        /Card> <
        /div>

        <
        div className = { `fade-in-right ${isVisionVisible ? 'visible' : ''}` }
        ref = { visionRef } >
        <
        Card >
        <
        CardContent >
        <
        h3 > Our Vision < /h3> <
        p >
        To become a trusted leader in the call center and debt collection industry by delivering innovative, efficient, and customer - focused solutions. <
        /p> <
        /CardContent> <
        /Card> <
        /div> <
        /div> <
        /div> <
        /section>
    );
};

export default AboutContent;